export default {"src":"/_next/static/media/gusd.0aa2e3fa.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};